import React from 'react';
import useStyle from './tableInfoContent.style';
import { classNames } from 'helpers/style/classNames';

export interface TableMyResultContentProps {
  color: 'Blue' | 'White';
  contents: (string | number)[];
  isNotes?: boolean;
}

export const TableInfoContent = ({
  color,
  contents,
  isNotes
}: TableMyResultContentProps) => {
  const classes = useStyle();

  return (
    <div
      className={classNames([classes.root, classes[color]], {
        condition: isNotes,
        classe: classes.isNotes
      })}
    >
      {contents.map((content, i) => (
        <span key={i}>{content}</span>
      ))}
    </div>
  );
};
